module.exports = __webpack_public_path__ + "static/media/video-dots.adc56ff1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/video-dots.png
// module id = 695
// module chunks = 0